import React, { useEffect, useRef, useState } from "react"
import { Box } from "@chakra-ui/react"

type Props = {
  buttonProps?: any
  dropdownProps?: any
  renderButton: any
  renderDropdown: any
  handleItemClick?: (item: any) => void
}

const Dropdown: React.FC<Props> = ({ buttonProps = {}, dropdownProps = {}, renderButton, renderDropdown, handleItemClick }) => {
  const ref = useRef<any>()
  const [open, setOpen] = useState(false)

  const onItemClick = (item: any) => {
    handleItemClick?.(item)
    setOpen(false)
  }

  useEffect(() => {
    const handleClickOutside = (e: any) => {
      if (ref.current && !ref.current?.contains(e.target)) {
        setOpen(false)
      }
    }

    document.addEventListener("mousedown", handleClickOutside)
    document.addEventListener("touchstart", handleClickOutside)
    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
      document.removeEventListener("touchstart", handleClickOutside)
    }
  }, [ref])

  return (
    <Box ref={ref} pos="relative" zIndex={10} {...buttonProps}>
      <Box userSelect="none" h="100%" cursor="pointer" onClick={() => setOpen(!open)}>
        {renderButton?.(open)}
      </Box>
      <Box
        color="brand.darkBlue"
        bgColor="primary.white"
        borderLeft="2px solid"
        borderRight="2px solid"
        borderBottom="2px solid"
        borderBottomLeftRadius="21.6px"
        borderBottomRightRadius="21.6px"
        borderColor="brand.darkBlue"
        w="100%"
        p={0}
        pt={1}
        pos="absolute"
        top="calc(100% - 2px)"
        overflow="hidden"
        display={open ? "block" : "none"}
        {...dropdownProps}
      >
        {renderDropdown?.(onItemClick)}
      </Box>
    </Box>
  )
}
export default React.memo(Dropdown)
